interface ConstellationLoaderProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const sizeClasses = {
  sm: 'w-8 h-8',
  md: 'w-16 h-16',
  lg: 'w-32 h-32',
  xl: 'w-48 h-48',
}

const dotSizes = {
  sm: 'w-1 h-1',
  md: 'w-1.5 h-1.5',
  lg: 'w-2 h-2',
  xl: 'w-3 h-3',
}

const centerSizes = {
  sm: 'w-2 h-2',
  md: 'w-3 h-3',
  lg: 'w-4 h-4',
  xl: 'w-6 h-6',
}

const orbitRadius = {
  sm: 30,
  md: 35,
  lg: 40,
  xl: 45,
}

export default function ConstellationLoader({ className = '', size = 'md' }: ConstellationLoaderProps) {
  const containerClass = sizeClasses[size]
  const dotClass = dotSizes[size]
  const centerClass = centerSizes[size]
  const radius = orbitRadius[size]

  return (
    <div className={`relative ${containerClass} ${className}`}>
      {/* Central glow */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className={`${centerClass} rounded-full bg-primary/50 animate-pulse shadow-[0_0_30px_10px_rgba(212,175,55,0.3)]`} />
      </div>
      
      {/* Orbiting dots */}
      {[0, 72, 144, 216, 288].map((angle, i) => (
        <div
          key={i}
          className={`absolute ${dotClass} rounded-full bg-primary/30 constellation-dot`}
          style={{
            top: `${50 + radius * Math.sin((angle * Math.PI) / 180)}%`,
            left: `${50 + radius * Math.cos((angle * Math.PI) / 180)}%`,
            transform: "translate(-50%, -50%)",
          }}
        />
      ))}
      
      {/* Connecting lines */}
      <svg className="absolute inset-0 w-full h-full opacity-20">
        <circle
          cx="50%"
          cy="50%"
          r={`${radius}%`}
          fill="none"
          stroke="currentColor"
          strokeWidth="0.5"
          strokeDasharray="4 4"
          className="text-primary animate-[spin_20s_linear_infinite]"
        />
      </svg>
    </div>
  )
}

